const levels = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3
};

let level = 'error';

class Logger {
  debug = (data, ...args) => {
    if (levels[level] <= levels.debug && console /* console not present on old IEs */) {
      console.log(data, ...args); // eslint-disable-line no-console
    }
  };

  info = (data, ...args) => {
    if (levels[level] <= levels.info && console /* console not present on old IEs */) {
      console.info(data, ...args); // eslint-disable-line no-console
    }
  };

  warn = (data, ...args) => {
    if (levels[level] <= levels.warn && console /* console not present on old IEs */) {
      console.warn(data, ...args); // eslint-disable-line no-console
    }
  };

  error = (data, ...args) => {
    if (console /* console not present on old IEs */) {
      console.error(data, ...args); // eslint-disable-line no-console
    }
  };

  setVerboseMode = debugLevel => {
    if (debugLevel === 'verbose') {
      level = 'debug';
      this.debug('Active verbose mode');
    } else {
      level = 'error';
    }
  };

  setLogger = (newLogger?) => {
    logger = newLogger;
  };
}

let logger = new Logger();

export default logger;
